import React from 'react';

import { numberWithComma, decimalPlace2 } from 'src/utils/Utils';
import styles from './PayrollTableData.scss';
import Row from './Row';
import BoldRow from './BoldRow';
import { useTranslation } from 'react-i18next';

const PayrollSummaryDetail = ({ payroll }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.paymentClm}>
      {payroll && (
        <div>
          <table className="m-table-obvious">
            <thead>
              <tr>
                <th colSpan="2">{t('features.MyData.components.payroll.PayrollSummaryDetail.total')}</th>
              </tr>
            </thead>
            <tbody>
              <Row
                label={t('features.MyData.components.payroll.PayrollSummaryDetail.net_amount_paid')}
                value={numberWithComma(decimalPlace2(payroll.transferAmount))}
              />
              <Row
                label={t('features.MyData.components.payroll.PayrollSummaryDetail.in_kind_payment_amount')}
                value={numberWithComma(decimalPlace2(payroll.genbutsuAmount))}
              />
              {payroll.transferWithBank.map(item => <BoldRow label={item.label} value={numberWithComma(decimalPlace2(item.value))} key={item.id} />)}
            </tbody>
          </table>
          <table className="m-table-obvious u-mt10">
            <thead>
              <tr>
                <th>{t('features.MyData.components.payroll.PayrollSummaryDetail.remarks')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="m-table-obvious-remarks">
                  <div className={styles.remarks}>{payroll.memo}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PayrollSummaryDetail;
